import { render, staticRenderFns } from "./ruleConfigList.vue?vue&type=template&id=b6e663de"
import script from "./ruleConfigList.vue?vue&type=script&lang=js"
export * from "./ruleConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports